"use client";

import Link from "@components/Link";
import type { BaseCategoryLinkFragment } from "@server/gql/graphql";

import { cn } from "@/lib/utils";

type Props = {
  slugs?: (BaseCategoryLinkFragment | null)[] | null;
  locale?: string;
  basePath: string;
  currentPath?: string;
};

export default function BrandAndDesignerCategories(props: Props) {
  return (
    <div className="mt-4 flex max-w-4xl flex-wrap gap-2 overflow-x-auto scrollbar-none max-md:-mx-4 max-md:px-4 md:mt-6">
      {props?.slugs?.map((category) => {
        if (!category) return null;
        return (
          <Link
            key={category.internalLink?.slug}
            locale={props?.locale}
            href={`${props?.basePath}${category.internalLink?.slug}`}
            className={cn(
              props?.currentPath === category.internalLink?.slug
                ? "btn-primary pointer-events-none"
                : "btn-outlined",
              "flex h-8 items-center justify-center whitespace-nowrap px-2",
            )}
          >
            <p>{category?.title}</p>
          </Link>
        );
      })}
    </div>
  );
}
